<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="Student Progress Analysis">
      <v-card-actions>
        <v-btn elevation="1" absolute right top color=" primary lighten-2"
          @click="downloadReportPDF(progressReportList)"> Download as PDF</v-btn>
      </v-card-actions>
      <div v-if="isPdf" id="mainContent">
        <student-analysis-report :graphImages="graphImages" :printData="printableData"
          :chartOptions="chartOptions" :scaleList="scaleList" :classReports='classReports'></student-analysis-report>
      </div>
      <v-card flat class="px-2">
        <v-row>
          <v-col cols="12" md="6" lg="2">
            <v-autocomplete class="my-0 py-1" label="Academic Year *" v-model="academicYearID"
              required item-value="id" :items="academicYears" key="id" item-text="academicYear">
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="6" lg="2">
            <v-autocomplete class="my-0 py-1" label="All Zone " name="sZone"
              @change="getFranchisee()" v-model="selectedSectionID" required item-text="zone"
              item-value="zone" :items="selectedZones" key="id" multiple>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="6" lg="2">
            <v-autocomplete multiple class="my-0 py-1" label="All Centers" name="sectionSelect"
              v-model="franchiseeID" required item-text="companyName" item-value="id"
              :items="centerList" @change="getClassList" key="id">
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="6" lg="2">
            <v-autocomplete multiple class="my-0 py-1" label="All Classes" name="classSelect"
              v-model="selectedClassID" required item-text="name" :items="classesList" key="id"
              return-object>
            </v-autocomplete>
          </v-col>

          <v-col cols="12" md="6" lg="2" style="max-width: 12%">
            <v-btn elevation="1" @click="getProgressReport()" color="primary">
              <v-icon left>mdi-content-save</v-icon>
              submit
            </v-btn>
          </v-col>
          <v-col cols="12" md="6" lg="2">
            <v-btn v-if="$vuetify.breakpoint.smAndUp" medium elevation="1" type="reset"
              @click="resetAll()">
              <v-icon left size="18"> mdi-restart</v-icon>
              Reset All
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
      <v-card-component>
        <div v-for="(item, index) of classReports" :key="index">
          <div v-if="progressReportList[item.id]">
            <v-row>
              <v-col cols="12">Class : {{ item.name }} </v-col>
              <v-col cols="12" md="6" lg="3">
                <v-autocomplete multiple class="my-0 py-1" label="All Terms" v-model="item.term"
                  required :items="item.termOptions" item-text="name" key="academicTerm.id"
                  return-object>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <v-autocomplete multiple class="my-0 py-1" label="All Skills" v-model="item.skills"
                  required @change="getSubSkills(index)" item-value="id" item-text="name"
                  :items="skillsList" key="id" return-object>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="2" lg="2">
                <v-autocomplete multiple class="my-0 py-1" label="All Sub Skills"
                  v-model="item.subSkills" required item-value="id" :items="subSkillsList" key="id"
                  item-text="name" @change="getParameter(index)" return-object>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="6" lg="2">
                <v-autocomplete multiple label="All Parameter" class="my-0 py-1"
                  v-model="item.parameter" required item-value="id" :items="parameterList"
                  item-text="name" key="id" return-object> </v-autocomplete>
              </v-col>

              <v-col cols="12" md="6" lg="2">
                <div class="inside">
                  <v-btn elevation="1" @click="getProgressReportV1(index, item.id)"
                    :class="{ 'mt-2': $vuetify.breakpoint.xs }" color="primary">
                    <v-icon left>mdi-content-save</v-icon>
                    submit
                  </v-btn>
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">Total student count : {{ getStudentCount(progressReportList[item.id]) }}
              </v-col>
              <div v-if="progressReportList">
                <div style="padding-left:12px;font-size: 15px;" v-if="!isData(progressReportList[item.id])">No Data Found!</div>
                <v-row>
                  <v-col v-for="(report, index2) in progressReportList[item.id]" :key="index2">
                    <div style="padding-left:12px">{{ report[0].AcademicTerm }}</div>
                    <div style="padding-left:12px">Count : {{ getStudentCount(progressReportList[item.id],report[0].AcademicTermMapID) }}</div>
                    <div class="vertical-divider hidden-sm-and-down pl-1"></div>
                    <div :id="item.id + report[0].AcademicTerm">
                      <apexchart type="pie" width="380" :options="chartOptions"
                        :series="seriesCount(report)" xaxis></apexchart>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-row>
            <v-divider class="mx-4"></v-divider>
          </div>
        </div>
      </v-card-component>
    </material-card>

    <loading-icon :value="isLoading" />
  </v-container>
</template>
<script>
import constants from '@/utils/constants'
import domtoimage from 'dom-to-image'
// import moment from 'moment'
import VCardComponent from '@/components/template/VCardComponent'
import MaterialCard from '@/components/template/MaterialCard'
import studentAnalysisReport from './studentAnalysisReport'

export default {
  components: { VCardComponent, MaterialCard, studentAnalysisReport },
  data () {
    return {
      isLoading: false,
      academicYears: [],
      selectedZones: [],
      centerList: [],
      classesList: [],
      skillsList: [],
      series: [20, 55, 13, 43],
      academicYearID: '',
      selectedSectionID: [],
      franchiseeID: [],
      selectedClassID: [],
      terms: [],
      selectedTerm: [],
      selectedSkill: [],
      subSkillsList: [],
      selectedSubSkill: [],
      scaleList: [],
      parameterList: [],
      name: '',
      className: [],
      selectedParameterID: [],
      labelsLoaded: false,
      progressReportList: [],
      isPdf: false,
      printableData: {},
      classReports: [],
      graphImages: {},
      loadingComponent: null
    }
  },
  computed: {
    chartOptions: function () {
      return {
        labels: this.scaleList,
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: 'bottom'
              }
            }
          }
        ]
      }
    }
  },
  async created () {
    await this.getAcademicYears()
    this.getFranchisee()
    this.getZoneDetails()
    this.getScales()
    this.getProgressReport()
  },
  methods: {
    seriesCount: function (report) {
      let temp = []
      this.scaleList.forEach((ScaleName) => {
        let searchIndex = report.map((a) => a.ScaleName).indexOf(ScaleName)
        if (searchIndex > -1) {
          temp.push(report[searchIndex].Students)
        } else {
          temp.push(0)
        }
      })
      return temp
    },
    isData: function (data) {
      if (Object.keys(data).length > 0) {
        return true
      } else {
        return false
      }
    },
    getAcademicYears: async function () {
      try {
        const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears`)
        this.academicYears = data.rows
        this.academicYearID = this.academicYears[1].id
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    getZoneDetails: async function () {
      try {
        this.isLoading = true
        let result = await http.get(`${constants.API_URL}/api/teacher-training/zone-options`)

        this.selectedZones = result.data
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getFranchisee: async function () {
      try {
        let zone = this.selectedSectionID
        const response = await http.post(`${constants.API_URL}/api/franchisee/get/zone-wise-franchisee`, {
          zone: zone
        })
        const data = response.data
        this.centerList = data
        this.classReports = []
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching center data', errorMessage)
        this.lock = false
        this.hasClicked = false
        this.$dialog.notify.info(errorMessage, {
          position: 'top-right',
          color: 'error',
          timeout: 2000
        })
      } finally {
      }
    },
    getClassList: async function () {
      try {
        this.isLoading = true
        const response = await http.post(`${constants.API_URL}/api/student/franchisee-class-section`, {
          franchiseeID: this.franchiseeID,
          academicYearID: this.academicYearID
        })
        const data = response.data
        this.classesList = data.map((a) => {
          a.term = []
          a.skills = []
          a.subSkills = []
          a.parameter = []
          return a
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getSkills: async function (classIds) {
      if (this.academicYearID === '') {
        this.errMsg('Kindly select Academic Year!')
        return false
      }

      try {
        this.isLoading = true

        const { data } = await http.post(`${constants.API_URL}/api/v1/grade-module/skill`, {
          classID: classIds,
          academicYearID: this.academicYearID
        })

        // this.skills = data.length > 0 ? data[0].gradeSkills : []
        // New api to fetch GradeSkills list with respect to AcademicYear, Class and Section
        // const { data } = await http.get(`${constants.API_URL}/api/grade-module/classSectionSkill?classID=${this.selectedClassID}&&academicYearID=${this.academicYearID}&&sectionID=${this.selectedSectionID}`)
        this.skillsList = data
        this.isLoading = false
      } catch (e) {
        this.isLoading = false

        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getSubSkills: async function (index) {
      if (this.selectedSkill === '') {
        this.errMsg('Kindly select Skill!')
        return false
      }
      try {
        this.isLoading = true
        const { data } = await http.post(`${constants.API_URL}/api/grade-module/get-sub-skill`, {
          gradeSkillID: this.classReports[index].skills.map(a => a.id)
        })

        this.subSkillsList = data.reduce((acc, items) => {
          acc = acc.concat(items.gradeSubSkills)
          return acc
        }, [])
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting Data: ${errorMessage}`)
      }
    },
    getParameter: async function (index) {
      try {
        this.isLoading = true
        let { data } = await http.post(`${constants.API_URL}/api/grade-module/parameter/get-parameters`, {
          gradeSkillID: this.classReports[index].skills.map(a => a.id),
          gradeSubSkillID: this.classReports[index].subSkills.map(a => a.id),
          academicTermID: this.classReports[index].term.map((a) => a.termId)
        })
        this.parameterList = data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getScales: async function () {
      try {
        this.isLoading = true
        let { data } = await http.get(`${constants.API_URL}/api/report/grade-scale`)
        this.scaleList = data.reduce((acc, items) => {
          acc = acc.concat(items.gradeScale)
          return acc
        }, [])

        this.labelsLoaded = true
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getProgressReport: async function (index = -1) {
      try {
        this.isLoading = true
        let { data } = await http.post(`${constants.API_URL}/api/report/student-progress-report`, {
          academicYearID: this.academicYearID,
          franchiseeID: this.franchiseeID,
          classID: this.selectedClassID.map((a) => a.id),
          academicTermsDateMapID: index > -1 ? this.classReports[index].term.map((a) => a.id) : [],
          gradeSkillID: index > -1 ? this.classReports[index].skills.map(a => a.id) : [],
          gradeSubSkillID: index > -1 ? this.classReports[index].subSkills.map(a => a.id) : [],
          gradeParameterID: index > -1 ? this.classReports[index].parameter.map(a => a.id) : []
        })
        this.progressReportList = data
        let classKeys = Object.keys(this.progressReportList)
        classKeys = classKeys.filter((a) => {
          a = Number(a)
          let keys = Object.keys(this.progressReportList[a])
          let searchIndex = this.classReports.map((b) => b.id).indexOf(a)
          if (searchIndex > -1) {
            this.classReports[searchIndex].termOptions = keys.map((termLabel) => {
              return {
                id: this.progressReportList[a][termLabel][0].AcademicTermMapID,
                name: termLabel,
                termId: this.progressReportList[a][termLabel][0].academicTermID
              }
            })
          }
          return searchIndex === -1
        })
        classKeys.forEach((cls) => {
          cls = Number(cls)
          let keys = Object.keys(this.progressReportList[cls])
          this.classReports.push({
            term: [],
            skills: [],
            subSkills: [],
            parameter: [],
            name: this.progressReportList[cls][keys[0]][0].Class,
            id: cls,
            termOptions: keys.map((termLabel) => {
              return {
                id: this.progressReportList[cls][termLabel][0].AcademicTermMapID,
                name: termLabel,
                termId: this.progressReportList[cls][termLabel][0].academicTermID
              }
            })
          })
        })
        this.getSkills(this.classReports.map((a) => a.id))
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getProgressReportV1: async function (index, classId) {
      try {
        this.isLoading = true
        let { data } = await http.post(`${constants.API_URL}/api/report/student-progress-report`, {
          academicYearID: this.academicYearID,
          franchiseeID: this.franchiseeID,
          classID: [classId],
          academicTermsDateMapID: index > -1 ? this.classReports[index].term.map((a) => a.id) : [],
          gradeSkillID: index > -1 ? this.classReports[index].skills.map(a => a.id) : [],
          gradeSubSkillID: index > -1 ? this.classReports[index].subSkills.map(a => a.id) : [],
          gradeParameterID: index > -1 ? this.classReports[index].parameter.map(a => a.id) : []
        })
        this.progressReportList[classId] = data.hasOwnProperty(classId) ? data[classId] : {}
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    downloadReportPDF: async function (reportList) {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        this.graphImages = {}
        for (let item of this.classReports) {
          let termsArr = this.progressReportList[item.id] ? Object.keys(this.progressReportList[item.id]) : []
          if (termsArr.length > 0) {
            this.graphImages[item.id] = {}
          }
          for (let trm of termsArr) {
            let ele = document.getElementById(item.id + trm)
            this.graphImages[item.id][trm] = await domtoimage.toPng(ele)
          }
        }
        this.isPdf = true
        this.printableData = reportList
        this.$nextTick(() => {
          this.printInvoice('printableArea')
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.loadingComponent.close()
      }
    },
    printInvoice: async function (content) {
      // Get HTML to print from element
      this.prtHtml = document.getElementById(content).innerHTML

      // Get all stylesheets HTML
      let stylesHtml = ''
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML
      }

      // Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=1300,toolbar=0,scrollbars=0,status=0')

      WinPrint.document.write(`<!DOCTYPE html>
      <html>
      <head>
      ${stylesHtml}
      </head>
      <body>
      ${this.prtHtml}
      </body>
      <style>

      @media print {
      .page-break {
      height: 0;
      page-break-before: always;
      margin: 0;
      border-top: none;
      }
      }

      body, p{
      font-size: 9pt;
      font-family: Arial, Helvetica, sans-serif;
      }

      body {
      margin-left: 2em;
      margin-right: 2em;
      padding-left: 2em;
      }

      .card{
      padding-left: 2em;
      }

      .page {
      height: 1300px;
      padding-top: 5px;
      page-break-after: always;
      font-family: Arial, Helvetica, sans-serif;
      position: relative;
      border-bottom: 1px solid #000;
      }
      </style>
      </html>`)

      WinPrint.document.close()

      WinPrint.focus()

      setTimeout(function () {
        WinPrint.print()
      }, 500)

      this.resetResult()
    },

    resetResult () {
      this.printableData = {}
      this.isPdf = false
    },
    getStudentCount (report, termId = null) {
      let terms = Object.keys(report)
      return terms.reduce((acc, term) => {
        if (termId) {
          // term wise student count
          if (report[term][0].AcademicTermMapID === termId) {
            return (
              acc +
          report[term].reduce((termStudentCount, a) => {
            return termStudentCount + Number(a.Students)
          }, 0)

            )
          } else {
            return acc
          }
        } else {
          // total student count
          return (
            acc +
          report[term].reduce((termStudentCount, a) => {
            return termStudentCount + Number(a.Students)
          }, 0)

          )
        }
      }, 0)
    },
    resetAll: function () {
      this.selectedSectionID = []
      this.franchiseeID = []
      this.selectedClassID = []
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
<style scoped>
.to-bottom {
  align-self: flex-end;
}

@media print {
  #mainContent {
    position: absolute;
    width: 100%;
    min-height: 100vh;
    top: 0;
    left: 0;
  }
}
</style>
